var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 54,
    viewBox: "0 0 30 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2C17 0.89543 16.1046 -4.82823e-08 15 0C13.8954 4.82823e-08 13 0.895431 13 2L17 2ZM13.5858 53.4142C14.3668 54.1953 15.6332 54.1953 16.4142 53.4142L29.1421 40.6863C29.9232 39.9052 29.9232 38.6389 29.1421 37.8579C28.3611 37.0768 27.0948 37.0768 26.3137 37.8579L15 49.1716L3.68629 37.8579C2.90524 37.0768 1.63891 37.0768 0.857866 37.8579C0.0768172 38.6389 0.0768173 39.9052 0.857866 40.6863L13.5858 53.4142ZM13 2L13 52L17 52L17 2L13 2Z",
    fill: "#FF671F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow.a88613cec130337d78acca26e81b04a5.svg";